import { P } from '@berlitz/globals'
import { getFileExtension } from '@utils/helpers'
import { getIcon } from '@utils/helpers/fileicons'
import uniqBy from 'lodash/uniqBy'
import * as React from 'react'
import Dropzone from 'react-dropzone'
import { FormattedMessage } from 'react-intl'
import { Col, Row } from 'react-styled-flexboxgrid'
import FilenameWithIcon from './FileContainer'
import { DropProp } from './interface'
import { StyledDropzone, StyledFileUpload, StyledH3, StyledLink, TitleWrapper } from './style'

class Dropfile extends React.PureComponent<DropProp> {
  static defaultProps = {
    disabled: false,
    onDrop: () => {},
  }
  state = {
    files: [] as File[],
  }

  render() {
    const { files } = this.state
    const { disabled, accepted, acceptedText } = this.props
    return (
      <>
        <Dropzone disabled={disabled} onDrop={this.onDrop} accept={accepted}>
          {({ getRootProps, getInputProps }) => (
            <div>
              <StyledDropzone disabled={disabled} {...getRootProps()}>
                <input {...getInputProps()} />
                <StyledFileUpload size="lg" />
                <Row>
                  <Col xs={false} md={12}>
                    <StyledH3>
                      <FormattedMessage id="Drop your files here to start uploading" />
                      <br />
                      {acceptedText ? (
                        <P>
                          <FormattedMessage id="accepted files" />
                          {': '}
                          <span>{acceptedText}</span>
                        </P>
                      ) : null}
                    </StyledH3>
                  </Col>
                </Row>
                <StyledLink>
                  <FormattedMessage id="Browse your files" />
                </StyledLink>
                {/*<StyledLink>*/}
                {/*  <FormattedMessage id="Attach previously uploaded file" />*/}
                {/*</StyledLink>*/}
              </StyledDropzone>
            </div>
          )}
        </Dropzone>
        {files.length > 0 && (
          <Row>
            <Col sm={12}>
              <TitleWrapper>
                <FormattedMessage id="Files added" />
              </TitleWrapper>
            </Col>
            {this.renderFiles()}
          </Row>
        )}
      </>
    )
  }

  private onDrop = (files: File[]) => {
    const nFiles = uniqBy(this.state.files.concat(files), (file: File) => file.name)

    this.setState({
      files: nFiles,
    })

    this.props.onDrop(nFiles)
  }

  private remove = (name: string) => {
    const nFiles = this.state.files.filter((file: File) => file.name !== name)

    this.setState({
      files: nFiles,
    })

    this.props.onDrop(nFiles)
  }

  private renderFiles = () => {
    const { files } = this.state
    return (
      <Col xs={12}>
        {files.map((file: File, index: number) => {
          const type = file.type || getFileExtension(file.name)
          const { Icon } = getIcon(type)

          return (
            <FilenameWithIcon key={index} name={file.name} onClose={() => this.remove(file.name)}>
              <Icon size="sm" />
            </FilenameWithIcon>
          )
        })}
      </Col>
    )
  }
}

export default Dropfile
